export default {"src":"/_next/static/media/emptyBasket.abcb5010.svg","height":202,"width":209,"blurWidth":0,"blurHeight":0};